module.exports = __webpack_public_path__ + "static/media/verdeBaby.2905214a.jpg";